export default "/images/cf573c4192aa1be7424b7bee5294c3a8.avif";